export default {
  vat: {
    title: 'VAT Identification Number',
    status_label: 'VAT Status',
    statuses: {
      pending_verification: 'Pending Verification',
      failed_verification: 'Failed Verification',
      verified: 'Verified',
    },
    countryCode: 'Country',
    vatId: 'VAT Identification Number',
    edit: 'Edit',
    addVat: 'Add a VAT Number',
    updateVat: 'Update VAT Number',
    save: 'Save',
    countryAlreadyUsed: 'You may only have one VAT Number per country.',
    vatIdExamples: 'Valid format(s) for %{countryName}: %{formats}.',
    vatIdAlphanumeric: 'Only letters and numbers.',
    vatEmptyStateMessage: 'Your shop may be required to have a VAT number depending on your country.',
    learnMore: 'Learn more.',
    saveFailed: 'Sorry, your VAT Number should match the following format(s):',
    deleteFailed: 'Sorry, your VAT Number could not be deleted. Please try again.',
    vatInfoTitle: 'Questions about adding a VAT ID?',
    vatInfoDescription: '{{children}} for more information.',
    visitHelpCenter: 'Visit our Help Center',
    upcomingVatOnFeesDescription: 'Reverb will begin assessing VAT on fees for sellers in the EU on 5 June',
    vatOnFeesDescription: 'Reverb began assessing VAT on fees for sellers in the EU on 5 June',
    addVatIdPrompt: "Add your VAT ID to help ensure you're not charged.",
  },
  australianGst: {
    title: 'Australian GST Registration Number',
    noGstMessage: 'Your shop may be required to have a GST registration number (ABN).',
    learnMore: 'Learn more.',
    registrationNumber: 'Registration Number',
    delete: 'Delete',
    registrationNumberHelpText: 'Valid format (ABN): 99999999999.',
    cancel: 'Cancel',
    submit: 'Submit',
    saveFailed: 'Unable to save your registration number. Please ensure it matches the accepted format and try again.',
    deleteFailed: 'Unable to delete your registration number. Please try again.',
    deleteSucceeded: 'Your registration number has been deleted.',
    saveSucceeded: 'Your registration number has been saved.',
  },
  onboardingBillingMethodLink: {
    completeBillingMethod: 'Complete Billing Method',
  },
  offerPolicy: {
    avoidLowballOffersLabel: 'Avoid receiving lowball offers',
    avoidLowballOffersSublabel: "Define what lowball means to you by entering a lowball percentage. Buyers won't be able to send you offers at or below this point.",
    lowballPercentageLabel: 'Lowball Percentage',
    lowballPercentageHelpText: 'Must be between %{minimum}% and %{maximum}%.',
    lowballPercentageError: 'Enter a percentage between %{minimum}% and %{maximum}%',
  },
  offerBotPolicy: {
    automaticAcceptLabel: 'Automatically accept or decline Offers from buyers',
    description: 'The Offer-Bot will only auto-respond to the fist offer recevied from a buyer. It will not respond if a buyer counters one of your offers or to offers that include a message.',
    conditionsTitle: 'Which items do you want to have automatic Offer responses?',
    conditionsTitleDescription: 'All listings with the selected conditions will apply.',
    conditionBrandNewOption: 'Brand New items',
    conditionBStockOption: 'B-Stock items',
    conditionUsedOption: 'Items in all Used conditions',
    boundariesTitle: 'Set price boundaries for automatic Offer responses',
    boundariesDescription: 'Automatically accept or decline offers for listings within the following price boundaries.',
    boundariesLowTitle: 'Lowest price',
    boundariesHighTitle: 'Highest price',
    autoPercentageDescription: "What offer percentage of these listings' price are you willing to automatically accept?",
    autoPercentageExample: "Example: if you auto-accept offers that are 90% of the listing's price, you'll auto-accept $90 for a $100 item.",
    autoPercentageLabel: 'Auto-acceptance percentage',
    autoDeclineQuestion: 'Do you want to auto-decline offers below a low-ball threshold?',
    autoDeclineCheckboxLabel: 'Yes, decline offers below a low-ball threshold',
    autoDeclineCheckboxSublabel: "Enter a low-ball percentage. Buyers won't be able to send offers below this percentage of the listing's price.",
    lowballPercentageTitle: 'Lowball percentage',
    autoThresholdPercentageError: 'Enter a percentage between %{minimum}% and %{maximum}%',
    haggleProtectionQuestion: 'Do you want to auto-accept counter offers within 2% of your counter offer?',
    haggleProtection:'Yes, accept any counter offer within 2% of my counter offer',
  },
};
